import React from "react";

export default function Circle(props: any){
	let children = props?.children;
	let stroke = props?.params?.dataColor || '#000000';
	let backgroundColor = props?.frameProps?.backgroundColor;
	let fill = backgroundColor || 'none';
	
	
	const viewBoxSize = 1000
	// Circle dimensions
	const radius = viewBoxSize / 2;
	const space = 20;
	
	return <>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
			<defs><clipPath id="circleView"><circle cx={radius} cy={radius} r={radius - space}/></clipPath></defs>
			<g clipPath="url(#circleView)">
				<rect {...{ width: viewBoxSize, height: viewBoxSize, fill }}/>
				{children}
			</g>
			{/* Inner circle border (optional, for better visibility) */}
			<circle cx={radius} cy={radius} r={radius - space/2} fill={'none'} strokeWidth={space} stroke={stroke} />
		</svg>
	</>
}